import { c as _c } from "react/compiler-runtime";
import { Button } from '@svs/ui/react/button';
import { type ReactNode } from 'react';
type GameAnalysisCopyToBoardProps = {
  authorLongName: string;
  handleSubmit: (event: React.SubmitEvent<HTMLFormElement>) => Promise<void>;
};

/**
 * Renders the client-side buttons (copy to board) for an author's game analysis.
 *
 * @param root0 - The props object
 * @param root0.authorLongName - The author's long name of the current game analysis.
 * @param root0.handleSubmit - The submit handler for copying the analysis to the board.
 * @returns The GameAnalysisCopyToBoard component.
 */
function GameAnalysisCopyToBoard(t0) {
  const $ = _c(7);
  const {
    authorLongName,
    handleSubmit
  } = t0;
  let t1;
  if ($[0] !== handleSubmit) {
    t1 = e => {
      handleSubmit(e);
    };
    $[0] = handleSubmit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== authorLongName) {
    t2 = <Button type="submit" variant="outline" size="md">Använd {authorLongName}s rad som grundrad</Button>;
    $[2] = authorLongName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <form className="flex justify-center p-2" onSubmit={t1}>{t2}</form>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export default GameAnalysisCopyToBoard;